import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var Loading =
/** @class */
function (_super) {
  __extends(Loading, _super);

  function Loading() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.spinnerVisible = true;
    return _this;
  }

  Loading = __decorate([Component({
    name: 'Loading'
  })], Loading);
  return Loading;
}(Vue);

export default Loading;